import { SYS_BREAKPOINT_LG } from '@oneaudi/unified-web-common';
import styled from 'styled-components';
export const Placeholder = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  aspect-ratio: 16 / 9;
  background-color: #f2f2f2;
  margin-left: auto;

  @media screen and (min-width: ${SYS_BREAKPOINT_LG}) {
    ${(props) => !props.$compare &&
    `
      width: 486px;
      margin-left: auto;
    `}
  }
`;
export const Image = styled.img `
  width: 100%;
  aspect-ratio: 16 / 9;

  @media screen and (min-width: ${SYS_BREAKPOINT_LG}) {
    ${(props) => !props.$compare &&
    `
      width: 486px;
      margin-left: auto;
      max-width: inherit;
    `}
  }
`;
